module.exports = __webpack_public_path__ + "static/img/funny.414ea84f.jpg";